import React from 'react';
import { UserFactsDashboard } from './UserFactsDashboard';
import { cn } from '../../utils/cn';

interface UserFactsContainerProps {
  className?: string;
}

export const UserFactsContainer: React.FC<UserFactsContainerProps> = ({ 
  className
}) => {
  return (
    <div className={cn('w-full p-6 flex flex-col min-h-0 overflow-hidden bg-rm-bg-0', className)}>
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 shrink-0 gap-4">
        <div>
          <h1 className="text-2xl font-bold text-rm-primary-700">My Information</h1>

        </div>
      </div>

      {/* Dashboard Content */}
      <div className="flex-1 min-h-0 overflow-y-auto">
        <UserFactsDashboard />
      </div>
    </div>
  );
};

export default UserFactsContainer;
